import React from 'react';

import styled from 'styled-components';

import { canViewPricingData } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';
import { AICompetitiveIntelligenceType } from 'types/recommendations';

import { AICIRankingTabKey, OVERALL_VIEW_KEY } from './constants';
import MarketCategoryBreakdown from './MarketCategoryBreakdown';
import MarketPositionGraph from './MarketPositionGraph';
import MarketPositionSummary from './MarketPositionSummary';

const Container = styled.div`
  border-radius: 10px;
  border: solid 1px var(--line-gray);
  padding: 30px;
  display: flex;
  flex-flow: column;
  gap: 30px;
`;

type Props = {
  data?: AICompetitiveIntelligenceType;
  activeTab: AICIRankingTabKey;
  onActiveTabChange: (tab: AICIRankingTabKey) => void;
};

const MarketPosition = ({ data, activeTab, onActiveTabChange }: Props) => {
  const { selectedCommunity } = useAppSelector((state) => state.global);
  const { currentUser } = useAppSelector((state) => state.auth);
  const showPricingData = canViewPricingData(currentUser);
  const isOverall = activeTab === OVERALL_VIEW_KEY;

  return (
    <Container>
      <MarketPositionSummary data={data} />
      <MarketCategoryBreakdown
        communityId={selectedCommunity?.id}
        overallRanking={data?.ranking}
        primaryCommunityName={selectedCommunity?.name ?? null}
        relatedData={data?.related_data}
        activeTab={activeTab}
        onActiveTabChange={onActiveTabChange}
      />
      {isOverall && showPricingData && <MarketPositionGraph />}
    </Container>
  );
};

export default MarketPosition;
